import PropTypes from "prop-types";
import { DndProvider, Preview } from 'react-dnd-multi-backend';
import HTML5toTouch from 'react-dnd-multi-backend/dist/esm/HTML5toTouch';

/*
// This is an example preview function that should be passed to withUniversalDnd()
const touchPreview = ({itemType, item, style}) => {
    // render your preview
    return (
        <div style={{...style, backgroundColor: 'red'}}>
            itemType: {JSON.stringify(itemType)} <br/>
            item: {JSON.stringify(item)} <br/>
        </div>
    );
};
 */


export function withUniversalDnd(WrappedComponent) {
    const C = (props) => {
        const { touchPreview, ...remainingProps } = props;

        // If we don't have a function passed to us, then don't display a preview (default on IOS/Android).
        const generatorFunc = touchPreview ? touchPreview : () => {};

        return (
            <DndProvider options={HTML5toTouch} >
                <WrappedComponent {...remainingProps} />
                <Preview generator={generatorFunc} />
            </DndProvider>
        )
    }

    C.displayName = `withUniversalDnd(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
    C.propTypes = {
        touchPreview: PropTypes.func,
    }
    return C;
}
